import { ChatContainer, MainContainer, Message, MessageList } from '@chatscope/chat-ui-kit-react';
import { ActionIcon, Box, TextInput } from '@mantine/core';
import { MarkdownField } from '@refinedev/mantine';
import { IconArrowUp } from '@tabler/icons-react';
import { useState } from 'react';
import type { Message as MessageType } from '../hooks/useChatMessages';
import CustomMessageContent from './CustomMessageContent';

type ChatMessagesProps = {
  messages: MessageType[];
  onSendMessage: (message: string) => void;
  latestIncomingId: string | null;
};

export default function ChatMessages({
  messages,
  onSendMessage,
  latestIncomingId,
}: ChatMessagesProps) {
  const [msg, setMsg] = useState('');

  const handleSendMessage = () => {
    if (msg.trim()) {
      onSendMessage(msg);
      setMsg('');
    }
  };
  return (
    <MainContainer>
      <ChatContainer>
        <MessageList>
          {messages.map(message => (
            <Message
              key={message.id}
              model={{
                message: message.response.map(r => r.content).join('\n'),
                sender: message.sender,
                position: 'normal',
                direction: message.direction,
              }}
            >
              <Message.CustomContent>
                {message.direction === 'incoming' ? (
                  <CustomMessageContent
                    message={message}
                    isLatestIncoming={latestIncomingId === message.id}
                  />
                ) : (
                  <MarkdownField value={message.response.map(r => r.content).join('\n')} />
                )}
              </Message.CustomContent>
            </Message>
          ))}
        </MessageList>
        {/* eslint-disable react/no-unknown-property */}
        {/* @ts-expect-error needed by chat library */}
        <div as="MessageInput">
          <Box
            pt="md"
            px="sm"
            pb="xxl"
            style={{
              backgroundColor: 'var(--mantine-color-gray-0)',
              borderTop: '1px solid var(--mantine-color-gray-2)',
              boxShadow:
                '0px -1px 4px -2px rgba(16, 24, 40, 0.06), 0px 0px 8px -2px rgba(16, 24, 40, 0.10)',
            }}
          >
            <TextInput
              placeholder="Ask me a question... "
              value={msg}
              height={48}
              onChange={event => setMsg(event.currentTarget.value)}
              onKeyDown={event => {
                if (event.key === 'Enter') {
                  handleSendMessage();
                }
              }}
              rightSection={
                <ActionIcon
                  bg={msg.trim() ? 'black' : 'gray.4'}
                  size="md"
                  mr="xs"
                  onClick={handleSendMessage}
                  style={{ borderRadius: '8px' }}
                  disabled={!msg.trim()}
                >
                  <IconArrowUp size={16} color="white" />
                </ActionIcon>
              }
              styles={{
                input: { paddingRight: 48 },
              }}
            />
          </Box>
        </div>
      </ChatContainer>
    </MainContainer>
  );
}
